import { getIdentity } from "../components/common/commonFuncs";
import { config } from "../config";
import http from "./httpService";

////////////////////////////////////////////////////////////////
// TODO
const prefix = "/api/v2/list/";

const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////
export function getListValues(List_ID) {
  return http.get(apiEndpoint + prefix + "getListValues", {
    params: {
      List_ID: List_ID,
      Activity_By: getIdentity()
    },
  });
}

export function saveListValues(lid, values) {
  return http.post(apiEndpoint + prefix + "saveListValues", {
    List_ID: lid,
    List_Values: values,
    Activity_By: getIdentity(),
  });
}

export function removeValue(lvid) {
  return http.post(apiEndpoint + prefix + "removeValue", {
    List_Value_ID: lvid,
    Activity_By: getIdentity(),
  });
}
////////////////////// Attribute ///////////////////////////////
export function getListAttributes(List_ID) {
  return http.get(apiEndpoint + prefix + "listAttributes", {
    params: {
      List_ID: List_ID,
      Activity_By: getIdentity()
    },
  });
}

export function saveAttribute(AttrID, AttrName, LId) {
  return http.post(apiEndpoint + prefix + "saveAttribute", {
    Attribute_ID: AttrID,
    Attribute_Name: AttrName,
    List_ID: LId,
    Activity_By: getIdentity(),
  });
}

export function removeAttribute(lid, aid) {
  return http.post(apiEndpoint + prefix + "removeAttribute", {
    List_ID: lid,
    Attribute_ID: aid,
    Activity_By: getIdentity(),
  });
}
